function normalizeSalesPageWidgetShopifyCdnUrl(imageUrl) {
  const normalizedImageUrl = String(imageUrl || '').trim();
  if (!normalizedImageUrl) {
    return '';
  }

  return normalizedImageUrl.startsWith('//') ? `${window.location.protocol}${normalizedImageUrl}` : normalizedImageUrl;
}

function isSalesPageWidgetFallbackEnabled() {
  const params = new URLSearchParams(window.location.search || '');
  const config = window._salesPageWidgetConfig;
  const swValue = String(params.get('sw') || '').trim().toLowerCase();

  return (swValue ? swValue !== 'false' : true) &&
    config &&
    typeof config === 'object' &&
    config.enabled === true;
}

async function getSalesPageWidgetProductFeaturedImageUrl() {
  const response = await fetch(`${window.location.pathname}.js`);
  if (!response.ok) {
    return '';
  }

  const product = await response.json();
  return normalizeSalesPageWidgetShopifyCdnUrl(product?.featured_image || product?.images?.[0]);
}

async function showSalesPageWidgetFallbackProductFeaturedImage() {
  if (!isSalesPageWidgetFallbackEnabled()) {
    return;
  }

  if (String(window._offer_id || '').trim()) {
    return;
  }

  const image = document.querySelector('.product-main img');
  if (!image) {
    return;
  }

  try {
    const featuredImageUrl = await getSalesPageWidgetProductFeaturedImageUrl();
    if (!featuredImageUrl || String(window._offer_id || '').trim()) {
      return;
    }

    image.src = featuredImageUrl;
    image.removeAttribute('srcset');
    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
  } catch (error) {
    console.warn('Failed to load fallback product featured image', error);
  }
}

window.showSalesPageWidgetFallbackProductFeaturedImage = showSalesPageWidgetFallbackProductFeaturedImage;
